// compactContext.js — /compact (DeerFlow borrow): compactação MANUAL de contexto.
// @arch:pure-engine
//
// O usuário digita /compact no composer → um MARKER (system, metadata.kind=
// 'context_summary') entra nas mensagens da sessão com um digest determinístico da
// conversa. O feed visível fica INTACTO (o marker é só mais uma system row); o que
// muda é o histórico modelo-facing: buildAgentHistory RESETA no marker — turnos
// seguintes veem [digest + mensagens pós-marker] em vez da conversa inteira.
// v1 determinístico (sem LLM): instantâneo, offline, custo zero — pedidos do
// usuário + arquivos tocados + último estado do agente. Puro e testável.

const COMPACT_RE = /^\/compact\s*$/i;
const CONTINUE_RE = /^(continue|continua|continuar)\.?$/i;
const ASK_MAX = 8;
const CLIP_ASK = 200;
const CLIP_STATE = 500;

export function isCompactCommand(text) {
  return COMPACT_RE.test(String(text || '').trim());
}

const clip = (s, max) => {
  const t = String(s || '').replace(/\s+/g, ' ').trim();
  return t.length > max ? `${t.slice(0, max)}…` : t;
};

/** Digest determinístico da conversa: pedidos, arquivos tocados, estado final. */
export function buildCompactSummary(messages = []) {
  const asks = [];
  const files = new Set();
  let lastAgent = '';
  for (const m of Array.isArray(messages) ? messages : []) {
    if (!m || typeof m !== 'object') continue;
    if (m.role === 'user') {
      const t = String(m.content || '').trim();
      if (t && !CONTINUE_RE.test(t)) asks.push(clip(t, CLIP_ASK));
    } else if (m.role === 'agent' || m.role === 'assistant') {
      const t = String(m.content || '').trim();
      if (t) lastAgent = t;
    } else if (m.role === 'tool') {
      const meta = m.metadata || {};
      const tool = meta.tool || m.tool_name || '';
      if (/write_file|apply_edit|edit_file/.test(tool) && meta.path) files.add(String(meta.path));
    }
  }
  const parts = [];
  if (asks.length) {
    const recent = asks.slice(-ASK_MAX);
    const dropped = asks.length - recent.length;
    parts.push(`Pedidos do usuário${dropped > 0 ? ` (últimos ${recent.length} de ${asks.length})` : ''}:\n${recent.map((a) => `• ${a}`).join('\n')}`);
  }
  if (files.size) parts.push(`Arquivos criados/editados nesta sessão:\n${[...files].map((f) => `• ${f}`).join('\n')}`);
  if (lastAgent) parts.push(`Último estado reportado pelo agente:\n${clip(lastAgent, CLIP_STATE)}`);
  return parts.join('\n\n') || '(conversa sem conteúdo compactável)';
}

/** Marker persistível: system row no feed + reset do histórico modelo-facing. */
export function compactMarkerMessage(summary) {
  return {
    role: 'system',
    content: '📦 Contexto compactado — turnos seguintes usam o resumo abaixo no lugar do histórico antigo (o chat visível continua completo).',
    metadata: { kind: 'context_summary', summary: String(summary || '') },
  };
}
